/*
  Aurev PDP image viewer (Monvaline-style). Loaded on product pages by snippets/aurev-dm-serif.liquid.
  Tap / click a photo in the v2 gallery ([data-mv] [data-mv-slide]): full-screen white viewer,
  round close button top right, thumbnail strip along the bottom. Phones: swipe between photos,
  pinch or double-tap to zoom, drag to pan. Desktop: click to zoom at the pointer, move the mouse
  to explore, wheel zooms, arrow keys / side arrows change photo, Esc closes. Browser Back closes it.
  Photos come from the gallery already on the page, re-requested at 2400px wide.
*/
(function () {
  if (window.AurevZoom) return;
  var css = document.createElement('style');
  css.textContent = "\n  [data-mv] .mv-slide img { cursor: zoom-in; }\n  .az { position: fixed; inset: 0; z-index: 2147483000; background: #fff; display: flex; flex-direction: column; opacity: 0; visibility: hidden; transition: opacity .22s ease, visibility 0s linear .22s; }\n  .az.is-open { opacity: 1; visibility: visible; transition: opacity .22s ease; }\n  .az__top { flex: 0 0 auto; height: 96px; position: relative; }\n  .az__close { position: absolute; top: 20px; right: 18px; width: 56px; height: 56px; border-radius: 50%; border: 1.5px solid #111; background: #fff; color: #111; display: flex; align-items: center; justify-content: center; cursor: pointer; padding: 0; z-index: 3; }\n  .az__close svg { width: 20px; height: 20px; }\n  .az__stage { flex: 1 1 auto; position: relative; overflow: hidden; touch-action: none; user-select: none; -webkit-user-select: none; }\n  .az__track { display: flex; height: 100%; will-change: transform; }\n  .az__track.is-anim { transition: transform .32s cubic-bezier(.25,.8,.3,1); }\n  .az__slide { flex: 0 0 100%; height: 100%; display: flex; align-items: center; justify-content: center; overflow: hidden; }\n  .az__img { max-width: 100%; max-height: 100%; width: auto; height: auto; display: block; transform-origin: 50% 50%; will-change: transform; -webkit-user-drag: none; user-select: none; pointer-events: none; }\n  .az__img.is-anim { transition: transform .28s ease; }\n  .az__stage.is-zoomable { cursor: zoom-in; }\n  .az__stage.is-zoomed { cursor: zoom-out; }\n  .az__stage.is-zoomed.is-touch { cursor: grab; }\n  .az__arrow { position: absolute; top: 50%; transform: translateY(-50%); width: 48px; height: 48px; border-radius: 50%; border: 1px solid #d9d9d9; background: rgba(255,255,255,.92); color: #111; display: none; align-items: center; justify-content: center; cursor: pointer; z-index: 2; padding: 0; }\n  .az__arrow svg { width: 20px; height: 20px; }\n  .az__arrow--prev { left: 24px; }\n  .az__arrow--next { right: 24px; }\n  .az__thumbs { flex: 0 0 auto; display: flex; gap: 12px; overflow-x: auto; padding: 24px 16px calc(24px + env(safe-area-inset-bottom)); scrollbar-width: none; justify-content: safe center; }\n  .az__thumbs::-webkit-scrollbar { display: none; }\n  .az__thumb { flex: 0 0 auto; width: 64px; height: 64px; padding: 2px; border: 1.5px solid transparent; background: #fff; cursor: pointer; }\n  .az__thumb.is-active { border-color: #111; }\n  .az__thumb img { width: 100%; height: 100%; object-fit: cover; display: block; }\n  .az__count { position: absolute; top: 38px; left: 20px; font-size: 13px; letter-spacing: .04em; color: #111; }\n  html.az-lock, html.az-lock body { overflow: hidden !important; }\n  @media (min-width: 990px) {\n    .az__arrow { display: flex; }\n    .az__top { height: 88px; }\n    .az__thumbs { gap: 14px; }\n    .az__thumb { width: 72px; height: 90px; }\n  }\n";
  document.head.appendChild(css);

  function sized(src, w) {
    try { var u = new URL(src, location.href); u.searchParams.set('width', w); u.searchParams.delete('height'); u.searchParams.delete('crop'); return u.toString(); }
    catch (e) { return src; }
  }
  var X = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M4.5 4.5l11 11M15.5 4.5l-11 11" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
  var L = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M12.5 4.5L7 10l5.5 5.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var R = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M7.5 4.5L13 10l-5.5 5.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var root = document.createElement('div');
  root.className = 'az'; root.setAttribute('role', 'dialog'); root.setAttribute('aria-modal', 'true');
  root.setAttribute('aria-label', 'Product images'); root.setAttribute('aria-hidden', 'true');
  root.innerHTML =
    '<div class="az__top"><span class="az__count" data-az-count></span><button type="button" class="az__close" data-az-close aria-label="Close">' + X + '</button></div>' +
    '<div class="az__stage is-zoomable" data-az-stage><div class="az__track" data-az-track></div>' +
    '<button type="button" class="az__arrow az__arrow--prev" data-az-prev aria-label="Previous image">' + L + '</button>' +
    '<button type="button" class="az__arrow az__arrow--next" data-az-next aria-label="Next image">' + R + '</button></div>' +
    '<div class="az__thumbs" data-az-thumbs></div>';
  document.body.appendChild(root);

  var stage = root.querySelector('[data-az-stage]');
  var track = root.querySelector('[data-az-track]');
  var thumbsEl = root.querySelector('[data-az-thumbs]');
  var slides = [], thumbs = [], builtFor = null;

  /* (re)build the slides from the product gallery that was clicked */
  function build(gallery) {
    var imgs = Array.prototype.slice.call(gallery.querySelectorAll('[data-mv-slide] img'));
    var key = imgs.map(function (i) { return i.getAttribute('src'); }).join('|');
    if (builtFor === key) return;
    builtFor = key;
    track.innerHTML = ''; thumbsEl.innerHTML = '';
    slides = []; thumbs = [];
    imgs.forEach(function (im, k) {
      var src = im.getAttribute('src');
      var slide = document.createElement('div');
      slide.className = 'az__slide';
      slide.dataset.mediaId = im.closest('[data-mv-slide]').dataset.mediaId || '';
      var big = document.createElement('img');
      big.className = 'az__img'; big.alt = im.alt || ''; big.draggable = false;
      if (im.getAttribute('width')) { big.width = +im.getAttribute('width'); big.height = +im.getAttribute('height'); }
      big.dataset.azSrc = sized(src, 2400);
      slide.appendChild(big); track.appendChild(slide); slides.push(slide);
      var t = document.createElement('button');
      t.type = 'button'; t.className = 'az__thumb'; t.setAttribute('aria-label', 'Show image ' + (k + 1));
      t.innerHTML = '<img alt="" width="64" height="64">';
      t.firstChild.src = sized(src, 200);
      t.addEventListener('click', function () { go(k, true); });
      thumbsEl.appendChild(t); thumbs.push(t);
    });
    var many = slides.length > 1;
    root.querySelector('[data-az-prev]').hidden = !many;
    root.querySelector('[data-az-next]').hidden = !many;
    thumbsEl.style.visibility = many ? '' : 'hidden';
  }
  var countEl = root.querySelector('[data-az-count]');
  var MAX = 4, DBL = 2.5;
  var idx = 0, s = 1, tx = 0, ty = 0, open = false, pushed = false, lastFocus = null;

  function img(i) { return slides[i] && slides[i].querySelector('img'); }
  window.AurevZoom = { open: function (i) { show(i || 0); } };
  function load(i) { var el = img(i); if (el && !el.src) el.src = el.dataset.azSrc; }

  /* ---- zoom maths: transform = translate(tx,ty) scale(s), origin at the image centre ---- */
  function bounds() {
    var el = img(idx), sw = stage.clientWidth, sh = stage.clientHeight;
    var w = el.offsetWidth * s, h = el.offsetHeight * s;
    return { x: Math.max(0, (w - sw) / 2), y: Math.max(0, (h - sh) / 2) };
  }
  function clamp() { var b = bounds(); tx = Math.min(b.x, Math.max(-b.x, tx)); ty = Math.min(b.y, Math.max(-b.y, ty)); }
  function apply(anim) {
    var el = img(idx); if (!el) return;
    el.classList.toggle('is-anim', !!anim);
    el.style.transform = 'translate3d(' + tx + 'px,' + ty + 'px,0) scale(' + s + ')';
    stage.classList.toggle('is-zoomed', s > 1.01);
  }
  /* focal point relative to the stage centre */
  function focal(cx, cy) { var r = stage.getBoundingClientRect(); return { x: cx - r.left - r.width / 2, y: cy - r.top - r.height / 2 }; }
  function zoomTo(ns, cx, cy, anim) {
    ns = Math.min(MAX, Math.max(1, ns));
    var f = focal(cx, cy);
    tx = f.x - (f.x - tx) * (ns / s);
    ty = f.y - (f.y - ty) * (ns / s);
    s = ns; if (s <= 1.001) { s = 1; tx = 0; ty = 0; }
    clamp(); apply(anim);
  }
  function resetZoom() { var el = img(idx); s = 1; tx = 0; ty = 0; if (el) { el.classList.remove('is-anim'); el.style.transform = ''; } stage.classList.remove('is-zoomed'); }

  /* ---- navigation ---- */
  function setTrack(dx, anim) {
    track.classList.toggle('is-anim', !!anim);
    track.style.transform = 'translate3d(' + (-idx * stage.clientWidth + (dx || 0)) + 'px,0,0)';
  }
  function go(i, anim) {
    if (!slides.length) return;
    resetZoom();
    idx = (i + slides.length) % slides.length;
    load(idx); load(idx + 1); load(idx - 1 < 0 ? slides.length - 1 : idx - 1);
    setTrack(0, anim);
    thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === idx); t.setAttribute('aria-current', k === idx ? 'true' : 'false'); });
    if (thumbs[idx]) thumbs[idx].scrollIntoView({ block: 'nearest', inline: 'center', behavior: anim ? 'smooth' : 'auto' });
    if (countEl) countEl.textContent = slides.length > 1 ? (idx + 1) + ' / ' + slides.length : '';
  }

  function show(i) {
    if (open) return go(i, true);
    open = true; lastFocus = document.activeElement;
    document.documentElement.classList.add('az-lock');
    root.classList.add('is-open'); root.setAttribute('aria-hidden', 'false');
    go(i, false);
    try { history.pushState({ aurevZoom: 1 }, ''); pushed = true; } catch (e) { pushed = false; }
    root.querySelector('[data-az-close]').focus({ preventScroll: true });
  }
  function hide(fromPop) {
    if (!open) return;
    open = false;
    root.classList.remove('is-open'); root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('az-lock');
    resetZoom();
    if (pushed && !fromPop) { pushed = false; history.back(); }
    pushed = false;
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  window.addEventListener('popstate', function () { if (open) hide(true); });

  /* open from the product gallery */
  document.addEventListener('click', function (e) {
    var slide = e.target.closest && e.target.closest('[data-mv] [data-mv-slide]');
    if (!slide || !slide.querySelector('img') || e.target.closest('a,button,video')) return;
    build(slide.closest('[data-mv]'));
    var id = slide.dataset.mediaId, i = 0;
    for (var k = 0; k < slides.length; k++) if (slides[k].dataset.mediaId === id) { i = k; break; }
    show(i);
  });

  root.querySelector('[data-az-close]').addEventListener('click', function () { hide(false); });
  root.querySelector('[data-az-prev]').addEventListener('click', function () { go(idx - 1, true); });
  root.querySelector('[data-az-next]').addEventListener('click', function () { go(idx + 1, true); });
  document.addEventListener('keydown', function (e) {
    if (!open) return;
    if (e.key === 'Escape') hide(false);
    else if (e.key === 'ArrowLeft') go(idx - 1, true);
    else if (e.key === 'ArrowRight') go(idx + 1, true);
  });
  window.addEventListener('resize', function () { if (open) { clamp(); apply(false); setTrack(0, false); } });

  /* ---- gestures ---- */
  var pts = {}, mode = null, sx = 0, sy = 0, stx = 0, sty = 0, pinch = null, moved = false, lastTap = 0, lastTapX = 0, lastTapY = 0, t0 = 0;
  function list() { return Object.keys(pts).map(function (k) { return pts[k]; }); }
  function dist(a, b) { return Math.hypot(a.x - b.x, a.y - b.y); }

  stage.addEventListener('pointerdown', function (e) {
    if (e.target.closest('button')) return;
    try { stage.setPointerCapture(e.pointerId); } catch (err) {}
    pts[e.pointerId] = { x: e.clientX, y: e.clientY, type: e.pointerType };
    stage.classList.toggle('is-touch', e.pointerType !== 'mouse');
    var p = list();
    if (p.length === 2) {
      mode = 'pinch'; moved = true;
      pinch = { d: dist(p[0], p[1]), s: s, mx: (p[0].x + p[1].x) / 2, my: (p[0].y + p[1].y) / 2, tx: tx, ty: ty };
      setTrack(0, false);
    } else if (p.length === 1) {
      mode = s > 1.01 ? 'pan' : 'swipe'; moved = false; t0 = Date.now();
      sx = e.clientX; sy = e.clientY; stx = tx; sty = ty;
    }
  });

  stage.addEventListener('pointermove', function (e) {
    /* desktop: once zoomed, the photo follows the mouse (no button held) */
    if (e.pointerType === 'mouse' && !pts[e.pointerId]) {
      if (s > 1.01) {
        var r = stage.getBoundingClientRect(), b = bounds();
        tx = b.x * (1 - 2 * (e.clientX - r.left) / r.width);
        ty = b.y * (1 - 2 * (e.clientY - r.top) / r.height);
        apply(false);
      }
      return;
    }
    if (!pts[e.pointerId]) return;
    pts[e.pointerId].x = e.clientX; pts[e.pointerId].y = e.clientY;
    var p = list();
    if (mode === 'pinch' && p.length >= 2) {
      var ns = Math.min(MAX, Math.max(0.8, pinch.s * dist(p[0], p[1]) / pinch.d));
      var mx = (p[0].x + p[1].x) / 2, my = (p[0].y + p[1].y) / 2;
      var f = focal(pinch.mx, pinch.my);
      s = ns;
      tx = f.x - (f.x - pinch.tx) * (ns / pinch.s) + (mx - pinch.mx);
      ty = f.y - (f.y - pinch.ty) * (ns / pinch.s) + (my - pinch.my);
      apply(false);
      return;
    }
    var dx = e.clientX - sx, dy = e.clientY - sy;
    if (Math.abs(dx) > 6 || Math.abs(dy) > 6) moved = true;
    if (mode === 'pan') { tx = stx + dx; ty = sty + dy; clamp(); apply(false); }
    else if (mode === 'swipe' && slides.length > 1 && e.pointerType !== 'mouse') setTrack(dx, false);
  });

  function end(e) {
    if (!pts[e.pointerId]) return;
    var p = pts[e.pointerId]; delete pts[e.pointerId];
    var left = list().length;
    if (mode === 'pinch') {
      if (left === 0) { if (s < 1) { s = 1; tx = 0; ty = 0; } clamp(); apply(true); mode = null; }
      else { var q = list()[0]; mode = s > 1.01 ? 'pan' : null; sx = q.x; sy = q.y; stx = tx; sty = ty; }
      return;
    }
    var dx = e.clientX - sx;
    if (mode === 'swipe' && moved && p.type !== 'mouse') {
      var fast = Math.abs(dx) / Math.max(1, Date.now() - t0) > 0.4;
      if (slides.length > 1 && (Math.abs(dx) > stage.clientWidth * 0.18 || (fast && Math.abs(dx) > 30))) go(idx + (dx < 0 ? 1 : -1), true);
      else setTrack(0, true);
    } else if (!moved && e.type === 'pointerup') {
      if (p.type === 'mouse') {
        /* desktop click: toggle zoom at the pointer */
        if (s > 1.01) { s = 1; tx = 0; ty = 0; apply(true); } else zoomTo(DBL, e.clientX, e.clientY, true);
      } else {
        var now = Date.now();
        if (now - lastTap < 300 && Math.hypot(e.clientX - lastTapX, e.clientY - lastTapY) < 30) {
          if (s > 1.01) { s = 1; tx = 0; ty = 0; apply(true); } else zoomTo(DBL, e.clientX, e.clientY, true);
          lastTap = 0;
        } else { lastTap = now; lastTapX = e.clientX; lastTapY = e.clientY; }
      }
    }
    mode = null;
  }
  stage.addEventListener('pointerup', end);
  stage.addEventListener('pointercancel', end);

  stage.addEventListener('wheel', function (e) {
    if (!open) return;
    e.preventDefault();
    zoomTo(s * (e.deltaY < 0 ? 1.15 : 1 / 1.15), e.clientX, e.clientY, false);
  }, { passive: false });
  /* iOS Safari: stop the page itself pinch-zooming behind the viewer */
  ['gesturestart', 'gesturechange'].forEach(function (t) { root.addEventListener(t, function (e) { e.preventDefault(); }); });
})();
